import { sortBy } from "lodash";
import { Alert } from "PFComponents/alert";
import { CustomType, PermissionsGroup } from "PFTypes";
import React from "react";

import { setCustomTypeAccessLevel } from "../permissions_form_data";
import { FormData } from "../permissions_group_edit_page.types";
import PermissionsGroupItemsEdit from "../permissions_group_items_edit";

type PermissionsGroupSectionProps = {
  qaId: string;
  title: string;
  description: JSX.Element;
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  customTypes: CustomType[];
  accessLevelType: keyof PermissionsGroup["custom_types_access_levels"];
  errors: string | undefined;
};
export const PermissionsGroupSection = ({
  qaId,
  title,
  description,
  formData,
  setFormData,
  customTypes,
  accessLevelType,
  errors
}: PermissionsGroupSectionProps): JSX.Element => (
  <>
    <h2 style={{ marginTop: 50 }}>{title}</h2>
    {description}
    {errors && <Alert kind="error" title={errors} style={{ marginBottom: 20 }} />}
    {formData.custom_types_access_levels[accessLevelType] && (
      <PermissionsGroupItemsEdit
        dataTableQAId={qaId}
        isRWOnly={({ mandatory }) => !!mandatory}
        items={sortBy(customTypes, "display_as")}
        idToPermLevel={formData.custom_types_access_levels[accessLevelType]}
        handleChange={(ctId, level) => {
          setFormData((prevFormData) => ({
            ...prevFormData,
            ...setCustomTypeAccessLevel(accessLevelType, prevFormData, ctId, level)
          }));
        }}
        getItemName={({ name }) => name}
        getDisplayAs={({ display_as }) => display_as}
      />
    )}
  </>
);
